import React, { useState, useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import { Col, Container, Row, FormGroup, Alert } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { Dropdown } from 'semantic-ui-react';
import NumberFormat from 'react-number-format';

import { calculatorApi } from '../../services/CalculatorService';
import { countryOptionsPayoneer } from '../../helpers/country_helper_payoneer';

import Breadcrumbs from '../../components/Breadcrumb';
import PageLoader from '../../components/Loaders/newPageLoader';
import useLoadingProgress from '../../hooks/useLoadingProgress';

import box_weight from '../../assets/images/box-weight.png';
import ups from '../../assets/images/calculator/ups_icon.png';

export default function CalculatorPoland({ profileData, loading }) {
  const {
    data = [],
    isLoading,
    // isFetching,
    error,
    refetch
  } = calculatorApi.useFetchAllDataQuery(undefined, {
    refetchOnMountOrArgChange: false,
    refetchOnFocus: false
  });
  const [getUpsRates, { isLoading: isFetching }] = calculatorApi.useGetUpsRatesMutation();
  const [emsPrices, setEmsPricesData] = useState([]);
  const [boxSizes, setBoxSizesData] = useState([]);
  const [countriesTr, setCountriesTrsData] = useState([]);

  const { progress, step, visible } = useLoadingProgress({ isLoading, isFetching });
  useEffect(() => {
    if (data.destinations) {
      setEmsPricesData(JSON.parse(JSON.stringify(data.emsPrices)));
      setBoxSizesData(JSON.parse(JSON.stringify(data.boxSizes)));
      setCountriesTrsData(JSON.parse(JSON.stringify(data.countriesTrs)));
    }
  }, [data]);

  const [formState, setFormState] = useState({
    originCountry: 'PL',
    boxSize: '',
    boxSizeL: '',
    boxSizeW: '',
    boxSizeH: '',
    volumeWeight: 0,
    finalRates: []
  });
  const [isNewBox, setIsNewBox] = useState(false);
  const toggleNewIsNewBox = () => {
    setIsNewBox(prevState => !prevState);
  };

  const handleInputChange = (name, value) => {
    setFormState((prev) => ({
      ...prev,
      [name]: value.toUpperCase(),
    }));
  };
  const [postalCode, setPostalCode] = useState('');
  const handleInputDestChange = (name, value) => {
    console.log('handleInputDestChange:', name, value);
    setFormState((prev) => ({
      ...prev,
      [name]: value.toUpperCase()
    }));
    setPostalCode(      
      countryOptionsPayoneer.find(
        (o) => o.value?.toLowerCase() === value?.toLowerCase()
      )?.postalCode
    );
  };

  const handleNetWeightCalc = (e) => {
    const [weightStr = "0"] = String(e.target.value).split("/");
    const weight = parseInt(weightStr, 10) || 0;

    setFormState(prev => ({
      ...prev,
      volumeWeight: weight,
      display: false,
    }));
  };
  const handleCalculate = (e) => {
    const [boxNoStr = ""] = String(e.target.value).split("/");
    const boxNo = parseInt(boxNoStr, 10);

    const sel = boxSizes.find(v => v.boxSizeNo === boxNo);
    if (!sel) return; // nothing to update if not found

    const L = Number(sel.length) || 0;
    const W = Number(sel.width)  || 0;
    const H = Number(sel.height) || 0;

    const volumeWeight = ((L * W * H) / 6000).toFixed(2);
    // const volumeWeightm3 = (L * W * H) / 1_000_000;

    setFormState(prev => ({
      ...prev,
      boxSize: boxNoStr,
      boxSizeL: L,
      boxSizeW: W,
      boxSizeH: H,
      volumeWeight,
      display: false,
    }));
  };

  const handleCustomCalculate = (e) => {
    const { name, value } = e.target;

    setFormState(prev => ({
      ...prev,
      boxSizeL: name === 'L' ? Number(value) : prev.boxSizeL,
      boxSizeW: name === 'W' ? Number(value) : prev.boxSizeW,
      boxSizeH: name === 'H' ? Number(value) : prev.boxSizeH,
    }));
  };

  const agentCountriesWeight = emsPrices.filter((v, i, a) => a.findIndex((v2) => v2.netWeightEms === v.netWeightEms) === i);
  const UPS_SERVICE_CODES = {
    "07": "UPS Express",
    "08": "UPS Expedited",
    "11": "UPS Standard",
    "54": "UPS Worldwide Express Plus",
    "65": "UPS Worldwide Saver",
    // add others as you need them
  };
  const [rate, setRate] = useState(null);
  const handleValidCalculate = async (e, values) => {
    try {
      // const shipingInfo = { 
      //   shipFrom: {
      //     address1: '58 Boleslawa Krzywoustego, Wroclaw, Stoka 51-165 PL', city: 'Wroclaw', stateProvinceCode: 'PL', countryCode: 'PL', postalCode: '51-165'
      //   },
      //   shipTo: {
      //     address1: '', city: '', stateProvinceCode: '', countryCode: 'PT', postalCode: '2765-334'
      //   },
      //   packageWeight: 8, dimensions: { length: 41, width: 31, height: 28 } 
      // }
      const shipingInfo = { 
        shipFrom: {
          address1: '58 Boleslawa Krzywoustego, Wroclaw, Stoka 51-165 PL', city: 'Wroclaw', stateProvinceCode: formState.originCountry, countryCode: formState.originCountry, postalCode: values.originPostalCode
        },
        shipTo: {
          address1: '', city: '', stateProvinceCode: '', countryCode: formState.destCountry, postalCode: values.destPostalCode
        },
        packageWeight: formState.volumeWeight, dimensions: { length: formState.boxSizeL, width: formState.boxSizeW, height: formState.boxSizeH } 
      }
      const ratesResp = await getUpsRates(shipingInfo).unwrap()
      const usdRateResp = await fetch('https://open.er-api.com/v6/latest/PLN');
      const data = await usdRateResp.json();      
      setRate(data.rates.USD);
      const normalized = ratesResp.shipments.map(r => {
        return {
          serviceCode: r.serviceCode,
          serviceName: UPS_SERVICE_CODES[r.serviceCode] || 'UPS Service',

          publishedCharge: r.publishedCharge, 
          publishedCurrency: r.publishedCurrency, 
          negotiatedCharge: r.negotiatedCharge, 
          negotiatedCurrency: r.negotiatedCurrency 

        };
      });
      setFormState(prev => {
        return {
          ...prev,
          finalRates: normalized,
          display: true
        }
      });
    } catch (error) {
      const formattedErrors = error.data.errors.map(err => {
        return {
          ...err,
          message: err.message
        };
      });
      console.log('errors:', formattedErrors);
    }
  }
  const getCountryName = (country) => {
    const match = countryOptionsPayoneer.find(
      (o) => o.value?.toLowerCase() === country?.toLowerCase()
    );
    return match ? match.text : country;
  };  
  const charges = formState?.finalRates?.map(r => r.negotiatedCharge);
  // cheapest
  const minCharge = Math.min(...charges);
  // most expensive
  const maxCharge = Math.max(...charges);
  console.log(postalCode)
  return (
    <React.Fragment>
      <PageLoader progress={progress} step={step} visible={visible} />
      <div className='page-content'>
        <MetaTags>
          <title>Transportation Calculator Through Poland </title>
        </MetaTags>
          <Container fluid>
            {profileData.permissions.includes('shippingCalcAccess') ? (
              <>
              <Breadcrumbs title='Calculator' breadcrumbItem='Transportation Calculator Through Poland ' />
              <div id='card-section'>
                <Row id='card-section'>
                  <Col lg='2'></Col>
                  <Col lg='8'>
                    <div className='screen'>
                      <AvForm onValidSubmit={handleValidCalculate} style={{ height: '100%' }}>
                        <Row style={{ height: '100%' }}>
                          <Col lg='6' style={{ height: '100%' }}>
                            <div className="area">
                              {formState.display && (
                                formState.finalRates?.map((ups_rate, index) => {
                                  const isCheap = ups_rate.negotiatedCharge === minCharge;
                                  const isExp = ups_rate.negotiatedCharge === maxCharge;
                                  return (
                                    <Row className="ms-2 mt-4 area-text">
                                      <h2 className='text-start pb-2 area-text-title'><b><span className="gld">{ups_rate.serviceName}</span> {getCountryName(formState.originCountry)} <i className='mdi mdi-arrow-right font-size-24'></i> {getCountryName(formState.destCountry)}</b></h2>
                                      <Col md={12}>
                                        <Row>
                                          <Col md={2} className="ps-4 pt-2 text-center">
                                            <img src={ups} width="60" height="60" alt="" />
                                          </Col>
                                          <Col md={5} className="ps-3 pt-2 text-start">
                                            <h3 className="area-text-label">Published Charges:</h3>
                                            <h3 className={`area-text-value font-size-16 mb-0 ${isCheap ? "cheap" : ""} ${isExp ? "exp" : ""}`}>Total:</h3>
                                            <h6 className="area-text-value font-size-12 mt-0 ">(with taxes and discount)</h6>
                                          </Col>
                                          <Col md={5} className="ps-0 pt-2 text-start">
                                            <h5 className="area-text-label"><span className=""><NumberFormat value={ups_rate.publishedCharge} displayType='text' thousandSeparator={true} prefix='zł' /></span></h5>
                                            <h3 className={`area-text-value font-size-16 ${isCheap ? "cheap" : ""} ${isExp ? "exp" : ""}`}>
                                              <span className="pe-1"><NumberFormat value={(ups_rate.negotiatedCharge+20).toFixed(2)} displayType='text' thousandSeparator={true} prefix='zł' />  </span>
                                              (<NumberFormat value={((ups_rate.negotiatedCharge+20)*rate).toFixed(2)} displayType='text' thousandSeparator={true} prefix='$' />)
                                            </h3>
                                          </Col>
                                        </Row>
                                      </Col>
                                      <hr className='area-line mt-4' />
                                    </Row>
                                  )
                                })
                              )}
                            </div>
                          </Col>
                          <Col lg='6' className='ps-0'>
                            <Row className='mt-5 ms-0 me-1'>                      
                              <Col md={6}>
                                <FormGroup className='mb-3'>
                                  <Dropdown
                                    placeholder='Origin Country'
                                    fluid
                                    search
                                    selection
                                    options={countryOptionsPayoneer}
                                    className="calculator-select"
                                    name='originCountry'
                                    defaultValue='pl'
                                    onChange={(e, data) => handleInputChange(data.name, data.value)}
                                    id='originCountry'
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup className='mb-3'>
                                  <AvField name='originPostalCode' className="calculator-select" type='text' id='originPostalCode' required defaultValue='51-165' placeholder='Ship From Postal Code'/>
                                </FormGroup>
                              </Col>  
                            </Row>
                            <Row className='mt-5 ms-0 me-1'>                              
                              <Col md={6}>
                                <FormGroup className='mb-3'>
                                  <Dropdown
                                    placeholder='Destination Country'
                                    fluid
                                    search
                                    selection
                                    options={countryOptionsPayoneer}
                                    className="calculator-select"
                                    name='destCountry'
                                    onChange={(e, data) => handleInputDestChange(data.name, data.value)}
                                    id='destCountry'
                                  />
                                </FormGroup>
                              </Col>
                              <Col md={6}>
                                <FormGroup className='mb-3'>
                                  <AvField name='destPostalCode' className="calculator-select" type='text' id='destPostalCode' required placeholder='Decstination Postal Code' value={postalCode}/>
                                </FormGroup>
                              </Col>  
                            </Row>
                            <Row className='mt-5 ms-0 me-1'>
                              {!isNewBox ? (
                                <Col md={6}>
                                  <FormGroup className='mb-3'>
                                    <AvField name='boxSize' className="calculator-select" type='select' id='boxSizeID' onChange={(e) => handleCalculate(e)} disabled={isNewBox === true ? true : false}>
                                      <option>Box Size</option>
                                      {boxSizes.map((val, key) => (
                                        <option key={key} value={val.boxSizeNo + '/' + val.volWeight}>
                                          {val.boxSizeNo}
                                        </option>
                                      ))}
                                    </AvField>
                                  </FormGroup>
                                </Col>
                              ) : (
                                <>
                                  <Col md={2}>
                                    <FormGroup className='mb-3'>
                                      <AvField name='L' className="calculator-select" placeholder='Length' autoComplete='off' list='sizes' value='' onChange={(e) => handleCustomCalculate(e)} />
                                    </FormGroup>
                                  </Col>
                                  <Col md={2}>
                                    <FormGroup className='mb-3'>
                                      <AvField name='W' className="calculator-select" placeholder='Width' autoComplete='off' list='sizes' value='' onChange={(e) => handleCustomCalculate(e)} />
                                    </FormGroup>
                                  </Col>
                                  <Col md={2}>
                                    <FormGroup className='mb-3'>
                                      <AvField name='H' className="calculator-select" placeholder='Height' autoComplete='off' list='sizes' value='' onChange={(e) => handleCustomCalculate(e)} />
                                    </FormGroup>
                                  </Col>
                                </>
                              )}
                              <Col md={2} className=''>
                                <div className="calculator-button">
                                  <button type="button" name="" className="btn-work" onClick={() => toggleNewIsNewBox()}>Custom Box </button>
                                </div>
                              </Col>
                              <Col md={4}>
                                <FormGroup className='mb-3'>
                                  <AvField name='netWeight' className="calculator-select" type='select' id='netWeight' value={formState.selectedgrossWeight} required onChange={handleNetWeightCalc}>
                                    <option>Gross Weight</option>
                                    {agentCountriesWeight.map((val, key) => (
                                      <option key={key} value={val.netWeightEms + '/' + val.priceAmountEms}>
                                        {val.netWeightEms}
                                      </option>
                                    ))}
                                  </AvField>
                                </FormGroup>
                              </Col>
                            </Row>
                            <Row className='ms-0'>
                              <Col md={8} className="ps-4 pt-4">
                                {formState.boxSizeL && (
                                  <Row className='calculator-text'>
                                    <Col md={1}>
                                      <i className='bx bx-chevron-down-square font-size-20 mt-3 ms-1 me-2' />
                                    </Col>
                                    <Col md={11}>
                                      <h5 className='mt-3'>
                                        : <b>{formState.boxSizeL}cm</b> * <b>{formState.boxSizeW}cm</b> * <b>{formState.boxSizeH}cm</b> / <b>5000</b> =<b>{formState.volumeWeight}</b>
                                      </h5>
                                    </Col>
                                  </Row>
                                )}
                              </Col>
                              <Col md={4} className="text-starts">
                                {formState.volumeWeight !== 0 && (
                                  <div>
                                    <img src={box_weight} alt='' />
                                    <div className='weight-block'>
                                      <p>{formState.volumeWeight} kg</p>
                                    </div>
                                    <i className='fas fa-info-circle' data-tip='Chosen weight - the largest amount<br />between Gross Weight and Volume Weight' data-iscapture='true'></i>
                                  </div>
                                )}
                              </Col>
                            </Row> 
                            <Row className='ms-0 me-2 mt-4'>
                              <Col md={12}>
                                <div className="calculator-button" >
                                  <button className='btn-work' style={{ width: '100%' }}>Calculate </button>
                                </div>
                              </Col>
                            </Row>                    
                          </Col>
                        </Row>
                      </AvForm>
                    </div>
                  </Col>
                  <Col lg='2'></Col>
                </Row>
              </div>
              </>
            ) : (
              <Alert color='danger'> You do not have access to this page. </Alert>
            )}
          </Container>
      </div>
    </React.Fragment>
  );
}